import React from 'react';
import {projects2} from '../portfolio';
import EducationCard from './educationCard/EducationCard';
import "./Project.scss"

function Project() {
  const cstyle = {backgroundColor: 'blue'}
   return(
<div className="project-section" id="project">
<h1 className="project-heading">Longer Projects</h1>
        <div className="education-card-container">
          {projects2.projects.map((project, index) => (
            <EducationCard key={index} school={project} />
          ))}
        </div>
  <div className="card" style={cstyle}>

  </div>
</div>    
    )
}

export default Project;